module.exports = "/shifts/components/calendarHeader/managerHeaderMonth-c81f0d.html";